/**
 * Shared inline styles + nav helpers for the storefront auth screens.
 *
 * Public-site visual language (vanilla CSS, no MUI) so the brand's
 * storefront stays as lightweight as possible — no theming library
 * is loaded on the customer-facing path.
 */

export const wrap = {
  minHeight: '100vh',
  background: 'linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 24,
  fontFamily: '-apple-system, BlinkMacSystemFont, "Inter", Roboto, sans-serif',
};

export const cardStyle = {
  width: '100%',
  maxWidth: 420,
  background: '#fff',
  borderRadius: 16,
  padding: 32,
  boxShadow: '0 20px 60px -20px rgba(15,23,42,0.25)',
};

export const inputStyle = {
  width: '100%',
  padding: '11px 14px',
  borderRadius: 10,
  border: '1px solid #d1d5db',
  fontSize: 14,
  outline: 'none',
  marginBottom: 12,
};

export const primaryBtn = (color = '#422AFB') => ({
  width: '100%',
  background: color,
  color: '#fff',
  border: 'none',
  padding: '12px',
  borderRadius: 10,
  fontWeight: 600,
  fontSize: 14,
  cursor: 'pointer',
});

// Brand routes resolve from either /site/:brandRef/... (platform host)
// or bare /... (custom domain). brandPath returns the right form for
// the caller's current host.
export function brandPath(brand, suffix) {
  if (!brand?._id) return suffix; // custom-domain path
  return `/site/${brand._id}${suffix}`;
}

export function navigateToLogin(navigate, brand) {
  navigate(brandPath(brand, '/login'));
}
export function navigateToSignup(navigate, brand) {
  navigate(brandPath(brand, '/signup'));
}
export function navigateToAccount(navigate, brand) {
  navigate(brandPath(brand, '/account'));
}
